import React, { FC } from 'react';
import { BasicContainer, FlexRow } from '@minecraft.atoms';
import { useTranslation } from '@blocs.i18n';
import { useField } from 'formik';
import { CheckboxInput } from '@minecraft.molecules';
import { PAYMENT_METHOD_TYPE } from '../../enums/PaymentMethods';

export type PaymentPriorityCheckboxesProps = {
  onToggle: (type: PAYMENT_METHOD_TYPE.PRIMARY | PAYMENT_METHOD_TYPE.BACKUP, isChecked: boolean) => void;
};

export const PaymentPriorityCheckboxes: FC<PaymentPriorityCheckboxesProps> = ({ onToggle }) => {
  const { t } = useTranslation();
  const [{ value: paymentPriority = [] }] = useField<string[]>('paymentPriority');

  return (
    <FlexRow gap="2">
      <BasicContainer borderRadius="sm" borderPlacement="all" padding={2}>
        <CheckboxInput
          value={PAYMENT_METHOD_TYPE.PRIMARY}
          checked={paymentPriority.includes(PAYMENT_METHOD_TYPE.PRIMARY)}
          label={t('common:billing.card.primary.set')}
          onChange={() => onToggle(PAYMENT_METHOD_TYPE.PRIMARY, !paymentPriority.includes(PAYMENT_METHOD_TYPE.PRIMARY))}
        />
      </BasicContainer>
      <BasicContainer borderRadius="sm" borderPlacement="all" padding={2}>
        <CheckboxInput
          value={PAYMENT_METHOD_TYPE.BACKUP}
          checked={paymentPriority.includes(PAYMENT_METHOD_TYPE.BACKUP)}
          label={t('common:billing.card.backup.set')}
          onChange={() => onToggle(PAYMENT_METHOD_TYPE.BACKUP, !paymentPriority.includes(PAYMENT_METHOD_TYPE.BACKUP))}
        />
      </BasicContainer>
    </FlexRow>
  );
};
